<template>
    <div class="my-separator"></div>
</template>

<style scoped lang="scss">
.my-separator {
    width: 100%;
    height: 1px;
    background-color: $lightGrey;
    border-top: 1px solid $lightGrey;
    margin-top: 1rem;
    align-self: center;
}
</style>